<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1C1i5ao/tc-custom/9781645360742.jpg?1705540371740" alt="This image is the cover for the book Dat Dare Monster"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dat Dare Monster
      </h1>
      <p class="bookDescription body article font2">
        <p>Dat Dare Monster shares the story of a little girl explaining the tale of her short encounter with the monster under her bed. It is a children's story with a narrator who cannot pronounce her "th" sound properly and, therefore, it comes out as a "d" sound.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christina M. Mizerak
      </h2>
      
      <p class="authorDescription body article">Christina's love for storytelling and illustrations stem from the classic fairy tales she grew up on. Her whimsical outlook keeps her inner-child alive in creating funny stories adults and children can enjoy. Christina currently resides in Chandler, Indiana with her husband and a little monster.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?64ee0004